import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { MODELS } from '../../../constants/admin/settings';
import * as actions from '../../../actions/admin/models/organizations';

class Index extends Component {
    render() {
        return (
            <AdminTable
                enableSearch={true}
                buttonAction={this.props.toNew}
                fetchDataFunction={this.props.fetchList}
                openItem={this.props.openOrganization}
                model={MODELS.ORGANIZATION}
                deleteAction={this.props.deleteOrganizations}
                pagination={true}
            />
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Index);
